import { Link } from "react-router-dom";
import { ArrowRight, ThumbsUp } from "lucide-react";
import { areaBySlug, BADGE_LABELS, isSeeking } from "@/lib/projectMeta";

export const ProjectCard = ({ project, testidPrefix = "project-card" }) => {
  const area = areaBySlug(project.area);
  const AreaIcon = area.icon;
  const detailUrl = `/progetti/${project.slug}`;
  const fit = project.image_fit === "contain" ? "object-contain p-6 bg-white" : "object-cover";

  return (
    <article
      data-testid={`${testidPrefix}-${project.slug}`}
      className="group relative flex flex-col bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] rounded-3xl overflow-hidden transition-all hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(0,0,0,0.10)]"
    >
      <Link to={detailUrl} className="block aspect-[16/10] overflow-hidden bg-[#FBF9F6] relative">
        {project.image_url && (
          <img src={project.image_url} alt={project.title}
            className={`w-full h-full transition-transform duration-500 group-hover:scale-105 ${fit}`} loading="lazy" />
        )}
        {project.is_concept && (
          <span className="absolute top-3 left-3 rounded-full bg-black/70 backdrop-blur text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1">
            Concept · in sviluppo
          </span>
        )}
        <span className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 rounded-full text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1"
          style={{ backgroundColor: area.color }}>
          <AreaIcon className="w-3 h-3" /> {area.name}
        </span>
      </Link>

      <div className="p-6 flex-1 flex flex-col">
        <div className="flex flex-wrap gap-1.5 mb-3">
          {(project.badges || []).slice(0, 3).map((b) => (
            <span key={b}
              className={`text-[9px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full ${
                isSeeking(b) ? "bg-[#C15C3D] text-white" : "bg-[#2E4F3B]/10 text-[#2E4F3B]"
              }`}>
              {BADGE_LABELS[b] || b}
            </span>
          ))}
        </div>
        <Link to={detailUrl}>
          <h3 className="font-display text-xl sm:text-2xl font-black text-[#1A1A1A] leading-tight mb-2 group-hover:text-[#2E4F3B] transition-colors">
            {project.title}
          </h3>
        </Link>
        {project.payoff && <p className="text-sm font-semibold text-[#C15C3D] italic mb-2">{project.payoff}</p>}
        <p className="text-sm text-[#5C5C5C] leading-relaxed flex-1">{project.summary}</p>

        <div className="mt-5 flex items-center justify-between">
          <Link to={detailUrl} data-testid={`${testidPrefix}-read-${project.slug}`}
            className="inline-flex items-center gap-2 text-sm font-bold text-[#2E4F3B] hover:gap-3 transition-all">
            Scopri e sostieni <ArrowRight className="w-4 h-4" />
          </Link>
          {(project.like_count > 0) && (
            <span className="inline-flex items-center gap-1 text-xs text-[#5C5C5C] font-semibold">
              <ThumbsUp className="w-3.5 h-3.5" /> {project.like_count}
            </span>
          )}
        </div>
      </div>
    </article>
  );
};
